import { Config } from 'config/envConfig';
import axios from 'axios';

import { getUrl } from '../../components/pdfDisplay/utils';

export const authAPI = {
    login: async (credentials) => {
        const dynamicUrl = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/new_login`
        );

        const response = await fetch(dynamicUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
            credentials: 'include',
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Login failed');
        }

        return await response.json();
    },

    googleLogin: async (credentialResponse) => {
        const dynamicUrl = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/google_login`
        );

        const response = await fetch(dynamicUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentialResponse),
            credentials: 'include',
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Google login failed');
        }

        return await response.json();
    },
};

export const repoAPI = {
    getAllRepos: async (email, token) => {
        const dynamicUrl = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getAllChatsRepos/${email}`
        );
        const encodedToken = encodeURIComponent(token);

        const response = await fetch(dynamicUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${encodedToken}`,
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch repositories');
        }

        return await response.json();
    },

    getVirtualReposForParent: async (parentRepoId) => {
        const dynamicUrl = getUrl(
            `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/virtual_repo_routes/virtual-repos`
        );

        const response = await axios.get(dynamicUrl, {
            params: { parent_repo_id: parentRepoId },
        });

        const data = response?.data || {};
        return data.virtual_repos || [];
    },
};

export const chatAPI = {
    getQnAHistory: async (email, folderName, repoid) => {
        const dynamicUrl = getUrl(
            `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/get-qna-history/?email=${email}&foldername=${folderName}&repoid=${repoid}&chatonly=false`
        );

        const response = await fetch(dynamicUrl);

        if (!response.ok) {
            throw new Error('Failed to fetch chat history');
        }

        return await response.json();
    },

    sendMessage: async (repoId, query, email, fileToChat = '') => {
        const formData = new FormData();
        formData.append('repo_id', repoId);
        formData.append('query', query);
        formData.append('user_id', email);
        formData.append('file_to_chat', fileToChat);
        formData.append('interface', 'default');

        const response = await axios.post(
            getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/qna`
            ),
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        return response.data;
    },
};

export default { authAPI, repoAPI, chatAPI };
